import React from "react";
import "./footer.css";
import "../App.css";
import Logo from "../images/footer-logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FaFacebookSquare } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";
import { FaLinkedin } from "react-icons/fa6";
import { IoLogoWhatsapp } from "react-icons/io";
import { RiTelegram2Fill } from "react-icons/ri";
import { FaXTwitter } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa";
import EclipseOuter from "../images/Ellipse outer.png";
import EclipseInner from "../images/Ellipse inner.png";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      <div className="footer">
        <img
          src={EclipseOuter}
          alt="Eclipse Outer"
          className="eclipse-outer d-none d-sm-block"
        />
        <img
          src={EclipseInner}
          alt="Eclipse Inner"
          className="eclipse-inner d-none d-sm-block"
        />
        <div className="footer-top">
          <h2 className="lead-h2">
            Start planning your <br />{" "}
            <span className="orange-color">future</span> today.
          </h2>
          <p className="grey-p pt-3 pb-5" style={{ color: "#545454" }}>
            Join thousands of Nigerians securing their retirement with us.
          </p>
          <a
            className="open-acc-btn grey-p mt-3"
            href="/products/rsa"
            role="button"
            target="_blank"
          >
            Open An Account{" "}
            <FontAwesomeIcon className="chv-dwn--footer" icon={faArrowRight} />
          </a>
        </div>
        <div className="footer-gradient"></div>
        <div className="footer-bottom">
          <div className="cnt">
            <div
              id="mobile-view"
              className="ft-btm-1 d-flex justify-content-between align-items-center pb-3"
            >
              <div id="mobile-view" className="d-flex align-items-center">
                <img src={Logo} alt="Leadway Logo" className="footer--logo img-fluid" />
                <p className="footer-title ms-4">Secure your future today.</p>
              </div>
              <div id="mobile-view" className="div-2 d-flex align-items-center">
                <p className="me-4">Get our Newsletter</p>
                <div className="input">
                  <input
                    className="news-letter"
                    type="Email"
                    placeholder="Enter your email"
                  />
                  <button className="news-btn"> Subscribe</button>
                </div>
              </div>
            </div>
            <hr className="line-divide" />
            <div className="lists d-flex justify-content-between">
              <ul className="footer-ul">
                <li className="first-li">Company</li>
                <li>
                  <Link to="/about-us">About Us</Link>
                </li>
                <li>
                  <Link to="/leadership">Leadership</Link>
                </li>
                <li>
                  <Link to="/corporate-responsibility">CSR</Link>
                </li>
                <li>
                  <Link to="/careers">Careers</Link>
                </li>
                <li>
                  <Link to="/financial-reports">Financial Reports</Link>
                </li>
              </ul>
              <ul className="footer-ul">
                <li className="first-li">Services</li>
                <li>
                  {" "}
                  <Link to="/products/rsa"> Retirement Savings Account </Link>
                </li>
                <li>
                  <Link to="/products/avc">
                    {" "}
                    Additional Voluntary Contribution{" "}
                  </Link>
                </li>
                <li>
                  {" "}
                  <Link to="/products/cross-border-services">
                    {" "}
                    Cross Border Services{" "}
                  </Link>
                </li>
                <li>
                  {" "}
                  <Link to="/products/managed-funds"> Manage Funds</Link>
                </li>
                <li>
                  <Link to="/services/NSITF"> NSITF </Link>{" "}
                </li>
                <li>
                  <Link to="/products/personal-messaging-service">
                    Personal Messaging Services{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link to="/products/micro-pensions">Micro Pension</Link>
                </li>
                <li>
                  <Link to="/products/residential-mortgage-access">
                    {" "}
                    Residential Mortgage{" "}
                  </Link>
                </li>
              </ul>
              <ul className="footer-ul">
                <li className="first-li">Benefits & Support</li>
                <li>
                  <Link to="/services/withdrawal">Reasons for withdrawal </Link>
                </li>
                <li>
                  <Link to="/services/group-life">
                    Unpaid Grouplife and Accrued Right
                  </Link>
                </li>
                <li>
                     <Link to="/services/unpaid-credit"> 
                        Uncredited Contributions/Funds
                     </Link>
                </li>
                <li>
                  {" "}
                  <Link to="/services/payment-types">Payment Types</Link>
                </li>
                <li>
                  {" "}
                  <Link to="/frequently-asked-questions">FAQs</Link>
                </li>
              </ul>
              <ul className="footer-ul">
                <li className="first-li">Resources</li>
                <li>
                  <Link to="/blog">Blog</Link>
                </li>
                <li>
                  <Link to="/download">Downloads</Link>
                </li>
                <li>
                  <Link to="/fund-price">Fund Charts</Link>
                </li>
                <li>
                  <Link to="/gallery">Gallery</Link>
                </li>
                <li>
                  <Link to="#">Calculator</Link>
                </li>
                <li>
                  <Link to="/whistle-blower">Whistleblowing</Link>
                </li>
              </ul>
              <ul className="footer-ul">
                <li className="first-li">Contact</li>
                <li>
                  <Link to="/our-branch-network">Branch Network</Link>
                </li>

                <li>
                  For Enquiries pls contact us on: <br />
                  02-01-2800800/ 07007367873 <br /> or send email to <br />
                  <a href="mailto:infopfa@leadway.com">
                    {" "}
                    infopfa@leadway.com
                  </a>
                </li>
              </ul>
            </div>
            <hr className="line-divide" />
            <div className="socials-container">
              <div className="socials">
                <span className="social-bg">
                  <a className="no-decoration" href="https://web.facebook.com/leadwaypensure" target="_blank"> 
                    <FaFacebookSquare style={{ color: "#E3E7EA" }} />
                  </a>
                
                </span>
                <span className="social-bg">
                   <a className="no-decoration" href="https://www.instagram.com/leadwaypensure" target="_blank"> 
                  <AiFillInstagram style={{ color: "#E3E7EA" }} />
                  </a>
                </span>
                <span className="social-bg">
               <a className="no-decoration" href=" https://ng.linkedin.com/company/leadway-group" target="_blank"> 
                  <FaLinkedin style={{ color: "#E3E7EA" }} />
                  </a>
                </span>
                <span className="social-bg">
                 
                    <a href="https://wa.me/07018000800" target="_blank">
                              <IoLogoWhatsapp style={{ color: "#E3E7EA" }} />
                    </a>
        
               
                </span>
                <span className="social-bg">
                          <a href="https://t.me/07018000800" target="_blank">
                     
                  <RiTelegram2Fill style={{ color: "#E3E7EA" }} />
                       </a>
                </span>
                <span className="social-bg">
                   <a className="no-decoration" href="https://x.com/LeadwayPensure" target="_blank"> 
                  <FaXTwitter style={{ color: "#E3E7EA" }} />
                  </a>
                </span>
                <span className="social-bg">
                  <a className="no-decoration" href=" https://www.youtube.com/channel/UCez1mkhZvM9iw9C289IMPlQ" target="_blank"> 
                  <FaYoutube style={{ color: "#E3E7EA" }} />
                    </a>
                </span>
              </div>
            </div>
            <hr className="line-divide" />
            <div className="copyright d-flex justify-content-between mt-4">
              <p>Copyright &#169; 2026 Leadway PFA Limited </p>

              <div className="d-flex gap-4">
                <p>
                  <Link
                    style={{ color: "#FFFFFF80", textDecoration: "none" }}
                    to="/privacy"
                  >
                    Privacy Policy
                  </Link>
                </p>
                <p>
                  <Link
                    style={{ color: "#FFFFFF80", textDecoration: "none" }}
                    to="/privacy"
                  >
                    Terms & Conditions
                  </Link>
                </p>
              </div>
            </div>
            <h6 className="copyright text-center mt-3 mb-2">
              Web development & security by Goldhouse Digital
            </h6>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
